import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../axiosBaseQuery';
import { EnvelopeWithData } from '../Envelope';

export type CustomNotification = {
  noticeTitle: string;
  noticeDetails: string;
};

type CustomNotificationResponse = {
  NoticeTitle: string;
  NoticeDetails: string;
};

export type CustomNotificationRequest = {
  countryId: number;
};

export type TaxRateRequest = {
  countryId: number | string;
};

export type TaxRateResponse = {
  taxRate: number;
  taxRatePercentage: number;
};

export type CurrentDiscountRequest = {
  countryId: number | string;
};

export type CurrentDiscountResponse = {
  Discount: number;
  DiscountPercentage: number;
};

export type AllowOnlinePaymentRequest = {
  countryId: number | string;
};

export const organisationCountryApi = createApi({
  reducerPath: 'organisationCountryApi',
  baseQuery: axiosBaseQuery({ baseUrl: '/web-api' }),
  endpoints: (builder) => ({
    getCustomNotification: builder.query<CustomNotification, CustomNotificationRequest>({
      query: (request) => ({ url: `/b2c/api/organisationCountry/${request.countryId}/notification`, method: 'get' }),
      transformResponse: (noticeEnvelope: EnvelopeWithData<CustomNotificationResponse>) => ({
        noticeTitle: noticeEnvelope.Data.NoticeTitle,
        noticeDetails: noticeEnvelope.Data.NoticeDetails,
      }),
    }),
    getTaxRate: builder.query<TaxRateResponse, TaxRateRequest>({
      query: (request) => ({ url: `/b2c/api/organisationCountry/${request.countryId}/taxRate`, method: 'get' }),
      transformResponse: (taxRateEnvelope: EnvelopeWithData<number>) => ({
        taxRate: taxRateEnvelope.Data,
        taxRatePercentage: taxRateEnvelope.Data * 100,
      }),
    }),
    getCurrentDiscount: builder.query<CurrentDiscountResponse, CurrentDiscountRequest>({
      query: (request) => ({ url: `/b2c/api/organisationCountry/${request.countryId}/discounts/current`, method: 'get' }),
      transformResponse: (discountEnvelope: EnvelopeWithData<number>) => {
        return {
          Discount: discountEnvelope.Data,
          DiscountPercentage: Number((discountEnvelope.Data * 100).toFixed(2)),
        };
      },
    }),
    getAllowOnlinePayment: builder.query<boolean, AllowOnlinePaymentRequest>({
      query: (request) => ({ url: `/b2c/api/organisationCountry/${request.countryId}/allowOnlinePayment`, method: 'get' }),
      transformResponse: (allowOnlinePaymentEnvelope: EnvelopeWithData<boolean>) => allowOnlinePaymentEnvelope.Data,
    }),
  }),
});

export const { useGetCustomNotificationQuery, useGetCurrentDiscountQuery, useGetAllowOnlinePaymentQuery, useGetTaxRateQuery } = organisationCountryApi;
